export default __webpack_public_path__ + "static/media/assigneeChange.1f38b4d5.svg";